import React from "react";
import { Card, Form, Button } from "react-bootstrap";

import * as Md from "react-icons/md";
import * as Ri from "react-icons/ri";
import * as Bi from "react-icons/bi";

import "./contactUs.css";

export default function ContactUs() {
  const imageBackground = "./images/dark-leaves-2.jpg";
  return (
    <Card
      data-aos="zoom-in"
      className="p-0"
      id="contact"
      style={{
        borderRadius: "25px",
        boxShadow: "-10px 20px 30px rgba(0, 0, 0, 0.1)",
        border: "none",
        margin: "5%",
      }}
    >
      <Card.Body className="p-0">
        <div className="row p-0">
          <div className="col-md-7 p-5 contact-text">
            <div>
              <div
                className="p-0 fs-4 text-uppercase"
                style={{ color: "var(--primary)" }}
              >
                Contact
              </div>
              <div className="p-0 fs-1 fw-bold">Why people choose us</div>
              <hr
                style={{
                  width: "10%",
                  borderTop: "6px solid var(--primary)",
                  opacity: "1",
                  borderRadius: "10px",
                }}
              />
              <p>
                Greenway Landscaping is a leading landscaping company in Dubai.
                We specialize in creating stunning outdoor spaces that provide a
                relaxing atmosphere for families to enjoy. With expert design,
                installation, and maintenance services, we use top-quality
                materials and equipment to exceed our customers' expectations
                and deliver exceptional results.
              </p>

              <div className="row row-cols-2">
                <div className="col p-4 choose-us-div">
                  <div>
                    <div className="d-flex align-items-center">
                      <Bi.BiLandscape
                        size={50}
                        color={"var(--primary"}
                        className="me-4"
                      />
                      <div>
                        <div className="fw-bold">Expertise</div>
                        <div className="text-muted">
                          Expert advice on all landscaping services
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col p-4 choose-us-div">
                  <div>
                    <div className="d-flex align-items-center">
                      <Ri.RiCustomerService2Fill
                        size={50}
                        color={"var(--primary"}
                        className="me-4"
                      />
                      <div>
                        <div className="fw-bold">Service</div>
                        <div className="text-muted">
                          Exceptional customer service and support
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col p-4 choose-us-div">
                  <div>
                    <div className="d-flex align-items-center">
                      <Md.MdArchitecture
                        size={50}
                        color={"var(--primary"}
                        className="me-4"
                      />
                      <div>
                        <div className="fw-bold">Craftsmanship</div>
                        <div className="text-muted">
                          High quality workmanship and attention to detail
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col p-4 choose-us-div">
                  <div>
                    <div className="d-flex align-items-center">
                      <Ri.RiPriceTag3Line
                        size={50}
                        color={"var(--primary"}
                        className="me-4"
                      />
                      <div>
                        <div className="fw-bold">Affordability</div>
                        <div className="text-muted">
                          Affordable prices and packages
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 p-0 contact-form">
            <Form
              style={{
                backgroundImage: `url(${imageBackground})`,
              }}
            >
              <h1 className="text-light">Get in Touch</h1>
              <Form.Group controlId="formBasicName">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter your name" />
              </Form.Group>

              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Enter your email" />
              </Form.Group>

              <Form.Group controlId="formBasicMessage">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter your message"
                  style={{ overflow: "auto", resize: "none" }}
                />
              </Form.Group>

              <Button
                size="lg"
                type="submit"
                className="mt-4 d-flex w-100 justify-content-center"
                style={{
                  backgroundColor: "var(--primary)",
                  borderColor: "var(--primary)",
                }}
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
